import { useAuthState } from '@/app/providers/auth'
import { getTenantLinkComponentRule } from '@/helpers/tenants'
import { SPLITS, useFeatureFlag } from '@/helpers/useFeatureFlag'
import useTenant from '@/hooks/useTenant'
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft'
import { Box, Button } from '@mui/material'

import { useRouter, useSearchParams } from 'next/navigation'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useGmFiltersActions } from '../../store/gmFiltersStore'

export const BackToSupplierButton: React.FC = () => {
  const { t } = useTranslation()
  const auth = useAuthState()
  const tenant = useTenant()
  const showItemSearchVendorList = useFeatureFlag(SPLITS.GM_ITEM_SEARCH_VENDOR_LIST, {
    userId: auth.type === 'authenticated' ? auth.user?.id : '',
  })

  const searchParams = useSearchParams()

  const allVendorsLink = getTenantLinkComponentRule(
    '/office-catering/vendors',
    tenant.domain,
    false,
    false,
  )

  const href = useMemo(() => {
    const params = new URLSearchParams()

    const supplierFilterParams = [
      'supplierType',
      'cuisineTags',
      'bestForTags',
      'occasionTags',
      'dietaryTags',
      'keyDatesTags',
      'diversityOfOwnershipTags',
    ]

    supplierFilterParams.forEach((key) => {
      const value = searchParams?.get(key)
      if (value) params.set(key, value)
    })

    if (showItemSearchVendorList) {
      const itemSearchTerm = searchParams?.get('itemSearchTerm')

      if (itemSearchTerm) params.set('itemSearchTerm', itemSearchTerm)
    }

    const queryString = params.toString()

    return queryString ? `${allVendorsLink.uri}?${queryString}` : allVendorsLink.uri
  }, [allVendorsLink.uri, showItemSearchVendorList, searchParams])

  const router = useRouter()
  const { clearFilters } = useGmFiltersActions()

  const handleBackToSupplier = () => {
    clearFilters()
    router.push(href)
  }

  return (
    <Box mb={2} mt={{ xs: 2, md: 0 }}>
      <Button
        variant="contained"
        startIcon={<UTurnLeftIcon sx={{ transform: 'rotate(90deg)' }} />}
        onClick={handleBackToSupplier}>
        {t('marketplace:backToSupplier')}
      </Button>
    </Box>
  )
}
